export class PrototypeTag {
    static default: string = 'Default';

    meta: any;
    items: any[] = [];

    constructor(
        public tag?: string
    ) {
        if (!tag) {
            this.tag = PrototypeTag.default;
        }

        this.meta = { title: this.tag };
    }

    add(field: any) {
        this.items.push(field);
    }

    setTag(value: string) {
        if (this.tag !== value) {
            this.tag = value;
            this.meta.title = value;
        }
    }
}
